import { fromJS } from 'immutable';
import { getSelectedProduct, getProducts } from '@americanexpress/product-ducks';

export const CARD_MEMBER_INFO_REQUEST = 'modules/axp-benefits-choice-enroll/CARD_MEMBER_INFO_REQUEST';
export const CARD_MEMBER_INFO_SUCCESS = 'modules/axp-benefits-choice-enroll/CARD_MEMBER_INFO_SUCCESS';
export const CARD_MEMBER_INFO_ERROR = 'modules/axp-benefits-choice-enroll/CARD_MEMBER_INFO_ERROR';
export const CLEAR_CARD_MEMBER_INFO = 'modules/axp-benefits-choice-enroll/CLEAR_CARD_MEMBER_INFO';

export const fetchCardMemberInfo = () => (dispatch, getState) => {
  const state = getState();
  const product = getSelectedProduct(state);
  const selectedProduct = product ? getProducts(state)[product] : null;
  if (!selectedProduct) {
    return dispatch({ type: CARD_MEMBER_INFO_ERROR });
  }
  const {
    account: { display_account_number: lastDigits },
    product: { large_card_art: cardImage, description: cardName },
    profile: { first_name: displayName },
  } = selectedProduct;

  const data = {
    cardImage,
    cardName,
    displayName,
    lastDigits,
  };
  return dispatch({ type: CARD_MEMBER_INFO_SUCCESS, data });
};

export const clearCardMemberInfo = () => (dispatch) => {
  dispatch({ type: CLEAR_CARD_MEMBER_INFO });
};

// eslint-disable-next-line default-param-last -- needed
export default function reducer(state = fromJS({}), action) {
  switch (action.type) {
    case CARD_MEMBER_INFO_REQUEST:
      return fromJS({})
        .set('isFetching', true)
        .set('error', false);
    case CARD_MEMBER_INFO_SUCCESS: {
      if (action.data) {
        return state
          .set('isFetching', false)
          .set('data', action.data)
          .set('error', false);
      }
      return state
        .set('isFetching', false)
        .set('data', null)
        .set('error', true);
    }
    case CARD_MEMBER_INFO_ERROR:
      return state
        .set('isFetching', false)
        .set('data', null)
        .set('error', true);
    case CLEAR_CARD_MEMBER_INFO:
      return state
        .set('isFetching', false)
        .set('data', null)
        .set('error', false);
    default:
      return state;
  }
}
